

































import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { SearchService } from "@/services/api/search.service";
import { SearchResult } from "@/models/search/searchresult";
import { LanguageDto } from "@/server/app.dtos";

@Component
export default class SearchComponent extends Vue {
  @Getter("currentLanguage") currentLanguage!: LanguageDto;
  isOpen: boolean = false;
  isLoading: boolean = false;
  keyword: string = "";
  searchservice: SearchService = new SearchService();
  results: SearchResult[] | null = null;

  get formatedResults(): any[] {
    const groups = this.getGroups(this.results);
    const items: any = [];
    let i: number;
    for (i = 0; i < groups.length; i++) {
      const result = this.results?.filter(s => s.group == groups[i].Name);
      items.push({
        Group: groups[i],
        Results: result
      });
    }
    return items;
  }

  getGroups(array: any): any[] {
    if (array) {
      const groups: any[] = [];
      let i: number;
      for (i = 0; i < array.length; i++) {
        if (groups.filter(s => s.Name == array[i].group).length == 0) {
          groups.push({ Name: array[i].group, Icon: array[i].icon });
        }
      }
      return groups;
    }
    return [""];
  }

  close(): void {
    this.keyword = "";
    this.results = null;
  }

  search(): void {
    if (this.isLoading) return;
    if (this.keyword.length >= 3) {
      this.isLoading = true;
      this.searchservice
        .Search(this.currentLanguage, this.keyword)
        .then((response: SearchResult[]) => (this.results = response))
        .catch(() => (this.results = null))
        .finally(() => (this.isLoading = false));
    }
  }
}
